<div class="edp-card-widget card desktop">
    <div class="to-pay">
        <div class="card-header" *ngIf="!debt">
            <span class="card-title">{{ 'pt.edp.edponline.payment.title' | translate }} </span>
            <span class="card-icon">
                <i class="icon-edponline-EDP_Online_payment"  aria-hidden="true"></i>
            </span>
        </div>
        <div class="card-header" *ngIf="debt">
            <span class="card-title">{{ 'pt.edp.edponline.payment.title.debt' | translate | edpCapitalize }} </span>
            <span class="card-icon">
                <i class="icon-edponline-Bop-125"  aria-hidden="true"></i>
            </span>
        </div>
        <div class="card-body">
            <!-- SECÇÃO 1 -->
            <span class="value" [ngClass]="{'larger-font-size': isLargerFontSize}" [innerHTML]="value | edpDecimalSplit"></span>
            <!-- SECÇÃO 2 -->
            <span class="title" *ngIf="!(debt && totalDebtInvoices > 1)">{{ 'pt.edp.edponline.payment.period.title' | translate }}</span>
            <div class="period d-flex" [ngClass]="{'more-to-pay': debt && totalDebtInvoices > 1}">
                <div class="my-auto">
                    <span class="date" *ngIf="!(debt && totalDebtInvoices > 1)">
                        {{ dateFrom |  date: 'd MMM y' }}
                        {{ 'pt.edp.edponline.payment.date' | translate }}
                        {{ dateTo |  date: 'd MMM y' }}
                    </span>
                    <span class="text" *ngIf="debt && totalDebtInvoices > 1">
                        {{ 'pt.edp.edponline.payment.invoices1' | translate }}{{ totalDebtInvoices }}{{ 'pt.edp.edponline.payment.invoices2' | translate }}
                    </span>
                </div>
                <div class="my-auto ml-auto">
                    <a [routerLink]="[link]" [gaClickDatalayer]="'dashboardPayementDetails'" [extraGaClickDatalayer]="{formModal: link}">
                        <span class="more">{{ 'pt.edp.edponline.payment.period.see.detail' | translate }}</span>
                        <span class="d-inline-block align-middle mx-2">
                            <i class="icon-edponline-Bop-073 rotate-270 icon"  aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
            </div>
            <!-- SECÇÃO 3 -->
            <span class="conta-certa" *ngIf="contract?.HasContaCerta && !debt">7{{ 'pt.edp.edponline.payment.conta.certa' | translate }}</span>
            <div class="direct-debit" *ngIf="!debt">
                <i class="icon-edponline-Bop-036 icon"  aria-hidden="true"></i>
                <span class="description d-block" [innerHTML]="'pt.edp.edponline.payment.direct.debit.description' | translate"></span>
                <a [routerLink]="linkDirectDebt">{{ 'pt.edp.edponline.payment.direct.debit.link.text' | translate }}</a>
            </div>
            <div class="direct-debit center mt6" *ngIf="debt">
                <i class="icon-edponline-Bop-070 icon"  aria-hidden="true"></i>
                <span class="description d-block"><span class="red">{{'pt.edp.edponline.payment.title.debt.description.red' | translate}}</span>{{'pt.edp.edponline.payment.title.debt.description' | translate}}</span>
            </div>
            <div class="direct-debit center amount-to-pay" *ngIf="contract?.HasServiceFaturaSegura && debt">               
                <span class="description d-block red">{{'pt.edp.edponline.payment.title.debt.amounttopay.red' | translate}}</span>
            </div>
        </div>
    </div>
    <div class="payment-method">
        <edp-payment-method [contractSelected]="contract" [balance]="balanceObject" [isDebt]="debt" [dateLimit]="dateLimit" [paymentReferenceNoDebt]="paymentData"></edp-payment-method>
    </div>
</div>


<div class="edp-card-widget card mobile">
    <div class="card-header" *ngIf="!debt">
        <span class="card-title">{{ 'pt.edp.edponline.payment.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-EDP_Online_payment"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-header" *ngIf="debt">
        <span class="card-title red">{{ 'pt.edp.edponline.payment.title.debt' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-125"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body mobile">
        <!-- SECÇÃO 1 -->
        <div class="d-flex px-3">
            <div class="my-auto">
                <span 
                    class="value"
                    [innerHTML]="value | edpDecimalSplit"></span>
            </div>
            <div class="my-auto ml-auto" *ngIf="value <= '9999'">
                <a [routerLink]="[link]" [gaClickDatalayer]="'dashboardPayementDetails'" [extraGaClickDatalayer]="{formModal: link}">
                    <span class="more">{{ 'pt.edp.edponline.payment.period.see.detail' | translate }}</span>
                    <span class="d-inline-block align-middle mx-2">
                        <i class="icon-edponline-Bop-073 rotate-270 icon"  aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
        <!-- SECÇÃO 2 -->
        <span class="title px-3" *ngIf="!debt">{{ 'pt.edp.edponline.payment.period.title' | translate }}</span>
        <div class="period d-flex px-3">
            <div class="my-auto" *ngIf="!debt">
                <span class="date">
                    {{ dateFrom |  date: 'd MMM y' }}
                    {{ 'pt.edp.edponline.payment.date' | translate }}
                    {{ dateTo |  date: 'd MMM y' }}
                </span>
            </div>
            <div class="content-amount">
                <div class="my-auto" *ngIf="debt">
                    <span class="debt-description"><span class="red">{{'pt.edp.edponline.payment.title.debt.description.red' | translate}}</span>{{'pt.edp.edponline.payment.title.debt.description' | translate}}</span>
                </div>
                <div class="my-auto" *ngIf="contract?.HasServiceFaturaSegura && debt">
                    <span class="debt-description">{{'pt.edp.edponline.payment.title.debt.amounttopay.red' | translate}}</span>
                </div>
            </div>

            <div class="my-auto ml-auto see-detail" *ngIf="value > '9999'">
                <a [routerLink]="[link]" [gaClickDatalayer]="'dashboardPayementDetails'" [extraGaClickDatalayer]="{formModal: link}">
                    <span class="more">{{ 'pt.edp.edponline.payment.period.see.detail' | translate }}</span>
                    <span class="d-inline-block align-middle">
                        <i class="icon-edponline-Bop-073 rotate-270 icon"  aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
        <span class="conta-certa" *ngIf="contract?.HasContaCerta && !debt">7{{ 'pt.edp.edponline.payment.conta.certa' | translate }}</span>
        <div *ngIf="payment" class="payment-method-mobile">
            <edp-payment-method [contractSelected]="contract" [balance]="balanceObject" [isDebt]="debt" [dateLimit]="dateLimit" [paymentReferenceNoDebt]="paymentData"></edp-payment-method>
        </div>
    </div>

    <div *ngIf="!payment" class="card-footer cursor-pointer text-center" (click)="expand()">
        <span class="text-link">{{ 'pt.edp.edponline.payment.button.pay' | translate }}</span>
        <span class="ml-2">
          <i class="icon-edponline-Bop-073 font-weight-bold"  aria-hidden="true"></i>
        </span>
    </div>
    <div *ngIf="payment" class="card-footer closing cursor-pointer text-center" (click)="expand()">
        <span class="text-link">{{ 'pt.edp.edponline.payment.button.close' | translate }}</span>
        <span class="ml-2">
          <i class="icon-edponline-Bop-073 fa-rotate-180 font-weight-bold"  aria-hidden="true"></i>
        </span>
    </div>
</div>
